import throttle from 'lodash-es/throttle';

class List {
  constructor(list, vnode) {
    this.list = list;
    this.vnode = vnode;
    this.observer = null;
    this.firstUpdate = true;
    this.activeAccount = null;
    this.scrollTo = 0;
    this.prevScrollHeight = 0;

    this.isLoading = false;
    this.isCompleted = false;
    this.isScrolledToBottom = false;
    this.isScrolledToActiveItem = false;
    this.functions = {
      onScroll: throttle(this.onScroll.bind(this), 300),
    };

    this.init();
  }

  init() {
    this.list.style.scrollBehavior = 'smooth';
    this.list.addEventListener('scroll', this.functions.onScroll);
    this.observer = new MutationObserver(() => {
      this.checkScrollPosition();
      this.checkElPosition();
    });
    this.observer.observe(this.list, { childList: true, attributes: true });
  }

  checkScrollPosition() {
    if (this.prevScrollHeight !== this.list.scrollHeight) {
      this.list.style.scrollBehavior = '';
      this.list.scrollTop = this.prevScrollHeight;
      this.prevScrollHeight = this.list.scrollHeight;
      this.list.style.scrollBehavior = 'smooth';
    }
  }

  checkElPosition() {
    const active = this.list.querySelector('[aria-selected="true"]');

    if (this.activeAccount !== active) {
      this.activeAccount = active;

      if (active) {
        const visiblePointTop = this.list.scrollTop;
        const visiblePointBottom = this.list.scrollTop + this.list.clientHeight;

        const topElPoint = active.offsetTop;
        const bottomElPoint = active.offsetTop + active.clientHeight;
        if (bottomElPoint > visiblePointBottom) {
          this.isScrolledToActiveItem = true;
          this.scrollTo = this.list.scrollTop = bottomElPoint - this.list.clientHeight + 20;
        } else if (topElPoint < visiblePointTop) {
          this.isScrolledToActiveItem = true;
          this.scrollTo = this.list.scrollTop = topElPoint - 20;
        }
      }
    }
  }

  checkActiveItemVisible() {
    if (this.activeAccount) {
      const visiblePointTop = this.list.scrollTop;
      const visiblePointBottom = this.list.scrollTop + this.list.clientHeight;

      const topElPoint = this.activeAccount.offsetTop;
      const bottomElPoint = this.activeAccount.offsetTop + this.activeAccount.clientHeight;

      return ((visiblePointTop <= topElPoint) && (visiblePointBottom >= bottomElPoint));
    }
    return true;
  }

  onScroll(e) {
    if (this.isScrolledToActiveItem) {
      this.isScrolledToActiveItem = !this.checkActiveItemVisible();
      return;
    }

    if (e.target.scrollTop >= ((e.target.scrollHeight - e.target.offsetHeight) - 10)) {
      if (!this.isLoading && !this.isCompleted && !this.isScrolledToBottom) {
        this.isLoading = true;
        this.prevScrollHeight = this.list.scrollHeight;
        this.emit('onScrollBottom', { context: this, fn: this.onLoad.bind(this) });
      }
      this.isScrolledToBottom = true;
    } else if (this.isScrolledToBottom) this.isScrolledToBottom = false;
  }

  onLoad(isCompleted) {
    this.isLoading = false;
    this.isCompleted = isCompleted;
  }

  emit(name, data) {
    const handlers = (this.vnode.data && this.vnode.data.on) || (this.vnode.componentOptions && this.vnode.componentOptions.listeners);
    if (handlers && handlers[name]) handlers[name].fns(data);
  }

  off() {
    this.list.removeEventListener('scroll', this.functions.onScroll);
    this.observer.disconnect();
  }
}

const listExamples = {};

export default {
  inserted(el, value, vnode) {
    const { name } = value.value;
    listExamples[name] = new List(el, vnode);
  },
  unbind(el, value) {
    const { name } = value.value;
    if (name in listExamples) {
      listExamples[name].off();
      delete listExamples[name];
    }
  },
};
